
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gramas/[id]",
      function () {
        return require("private-next-pages/gramas/[id].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gramas/[id]"])
      });
    }
  